module.exports = __webpack_public_path__ + "img/vip.a0e544bf.svg";